import { classes, style, stylesheet } from 'typestyle'
import { get } from '../../../__aeki__/share/find'
import { useMemo } from 'react'

import { Box } from '../../../__aeki__/components/box/box.component'
import { Heading } from '../../../__aeki__/components/text/heading.component'
import { Images } from '../../childcare/components/images'
import { Line } from '../../../__aeki__/components/line'
import { RichTextView } from '../../../__aeki__/components/rich-text/richt-text-view'
import { Text } from '../../../__aeki__/components/text/text.component'

import { mb12 } from '../../../__aeki__/styles/styleset/margin/mb12'
import { mb20 } from '../../../__aeki__/styles/styleset/margin/mb20'
import { mb32 } from '../../../__aeki__/styles/styleset/margin/mb32'
import { mt20 } from '../../../__aeki__/styles/styleset/margin/mt20'
import { mt40 } from '../../../__aeki__/styles/styleset/margin/mt40'
import { p16 } from '../../../__aeki__/styles/styleset/padding/p16'
import { paddingVerticalOuter } from '../../../__aeki__/styles/default/padding'
import { pb0 } from '../../../__aeki__/styles/styleset/padding/pb0'
import { pb12 } from '../../../__aeki__/styles/styleset/padding/pb12'
import { pl16 } from '../../../__aeki__/styles/styleset/padding/pl16'
import { pr16 } from '../../../__aeki__/styles/styleset/padding/pr16'
import { pt12 } from '../../../__aeki__/styles/styleset/padding/pt12'
import { pt40 } from '../../../__aeki__/styles/styleset/padding/pt40'
import { pt0i } from '../../../__aeki__/styles/styleset/padding/pt0i'
import { pb0i } from '../../../__aeki__/styles/styleset/padding/pb0i'

export const BlogPostComponent = (props: any) => {
  const { post = { payload: {} } } = props
  const body = get('body.body', post.payload, 'array')

  const bodyComponent = useMemo(
    () =>
      body.map((section: any, key: any) => {
        const images =
          section?.images?.map?.((image: any) => {
            return image?.file?.body?.location
          }) || []

        return (
          <Box
            baseline="none"
            className={classes(paddingVerticalOuter)}
            key={key}
            maxWidth={800}
            relative
            row
            fullWidth
            centerAutoX
          >
            <Box id={`${section.subtitle}-${key}`} className={STYLES.containerHidden} absolute />
            <Box
              className={classes(key !== body.length - 1 && mb32)}
              baseline="none"
              maxWidth={800}
              row
              centerAutoX
              fullWidth
            >
              {section.subtitle != 0 && section.subtitle && (
                <Heading className={classes(mb20)} size="xl" semiBold>
                  {section.subtitle}
                </Heading>
              )}
              {images.length > 0 && (
                <Box className={classes(style({ cursor: 'pointer' }), mb12)} baseline="none">
                  <Images images={images} contain />
                </Box>
              )}
              <RichTextView __html={section.content} scroll={false} disablePadding />
            </Box>
            {section.summary !== 0 && section.summary && (
              <>
                <Box
                  baseline="none"
                  className={mt20}
                  style={{
                    background: '#f6f8ff',
                  }}
                  row
                  alignLeft
                >
                  <Line />
                  <Box
                    maxWidth={800}
                    centerAutoX
                    baseline="none"
                    className={classes(pt12, pb12)}
                    row
                    fullWidth
                  >
                    <Box baseline="none" className={classes(pl16, pr16, pb0)}>
                      <Text baseline="surface" size="xs" bold lighter uppercase>
                        Summary
                      </Text>
                    </Box>
                    <Box baseline="none" rounded row className={classes(p16, pb0i, pt0i)}>
                      <Text size="md" baseline="surface" readable>
                        {section.summary}
                      </Text>
                    </Box>
                  </Box>
                  <Line />
                </Box>
              </>
            )}
            <Box className={mt40} row>
              {/* <Line /> */}
            </Box>
          </Box>
        )
      }),
    [],
  )

  // const authorComponent = useMemo(
  //   () => (
  //     <>
  //       <Line />
  //       <Box
  //         baseline="none"
  //         className={classes(pt40, pb40, paddingVerticalOuter)}
  //         maxWidth={800}
  //         fullWidth
  //         centerAutoX
  //         row
  //       >
  //         <Text className={mb8} size="sm" baseline="surface" bold lighter uppercase>
  //           Author
  //         </Text>
  //         <Text className={mb16} size="lg" semiBold>
  //           {author.fullName}
  //         </Text>
  //         <Text className={mb16} size="md" readable>
  //           {author.bio}
  //         </Text>
  //         <Box baseline="none">
  //           <Button
  //             baseline="primary"
  //             size="md"
  //             label={`Ask ${author.firstName} anything about childcare!`}
  //             square
  //             onClick={async () => {
  //               const { Modal } = await import('../../../__aeki__/components/modal')
  //               await import('../../../__aeki__/default/modals/contact-us')
  //               Modal.push({
  //                 type: 'ContactUs',
  //                 componentProps: { pathName: '/a/contact-us' },
  //               })
  //             }}
  //           />
  //         </Box>
  //       </Box>
  //     </>
  //   ),
  //   [],
  // )

  return (
    <Box baseline="background" row flex>
      <Box row fullWidth>
        <Box baseline="surface" className={classes(pt40)} centerAutoX row fullWidth>
          <Box baseline="none" row fullWidth>
            {bodyComponent}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

const STYLES = stylesheet({
  containerHidden: {
    top: -100,
    visibility: 'hidden',
  },
})
